<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import { getKennungValue, getKennungValueDisplay } from "@/DataHelper";

let dateVorgesetzter = ref<Date | null>(null);
let textMitarbeiter = ref<string>("");
let iconAmpel = ref<string>("");
let ampelDaten: number;
let iconFarbe = ref<string>("");
const emit = defineEmits(["back", "save"]);

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WEB_ErfassungMemo_Freigabe",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  pageParams.zeitbereich = AUApi.Current.zeitbereich;
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data[0]) {
    dateVorgesetzter.value = getKennungValueDisplay(
      uiData.data[0],
      "ZE_FREIGABE_ABLEHNUN",
      uiData.columns
    );
    textMitarbeiter.value = getKennungValueDisplay(
      uiData.data[0],
      "MEMO_MITARBEITER",
      uiData.columns
    );
    iconAmpel.value = getKennungValueDisplay(
      uiData.data[0],
      "ampel",
      uiData.columns
    );
    ampelDaten = getKennungValue(uiData.data[0], "ampel", uiData.columns);
    if (ampelDaten === 0) {
      iconFarbe.value = "grey";
    } else if (ampelDaten === 1) {
      iconFarbe.value = "green";
    } else if (ampelDaten === 2) {
      iconFarbe.value = "orange";
    } else if (ampelDaten === 3) {
      iconFarbe.value = "red";
    }
    if (!iconAmpel.value) {
      iconAmpel.value = "<img src='/" + 0 + "_Ampel.png' alt='" + 0 + "' />";
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
function save() {
  onSave(uiData, pageParams).then(() => {
    nextTick(() => emit("save"));
  });
}
</script>
<template>
  <v-expansion-panels tile>
    <v-expansion-panel
      v-if="uiData.initialized"
      :style="{ border: `1px solid ` }"
    >
      <v-expansion-panel-title disable-icon-rotate class="subtitle-1 lighten-2">
        <v-icon v-if="iconAmpel" size="x-large" :color="iconFarbe"
          >mdi-circle-slice-8</v-icon
        >
        <span v-if="dateVorgesetzter">Freigabe: {{ dateVorgesetzter }}</span>

        <template v-slot:actions>
          <v-icon> mdi-menu-down </v-icon>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text class="timeCard">
        <v-card>
          <v-card-text>
            <!-- <div>Memo Mitarbeiter: {{ textMitarbeiter }}</div> -->
            <EditTextArea
              class="dvhCol"
              kennung="MEMO_MITARBEITER"
              description="Memo Mitarbeiter"
              :clearable="false"
              :rows="4"
              :readonly="true"
            />
            <!-- <span>Memo Vorgesetzter:</span> -->
            <EditTextArea
              class="dvhCol"
              kennung="MEMO_VORGESETZTER"
              description="Memo Vorgesetzter"
              :clearable="false"
              :rows="4"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer> </v-spacer>

            <v-btn
              color="green"
              @click="save"
              icon="mdi-content-save"
              variant="flat"
              rounded="0"
              density="comfortable"
            >
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>
.timeCard {
  min-width: 200px;
  padding-right: 5px;
  max-width: 100%;
  font-size: 14px;
}
.dvhCol {
  padding-right: 0px;
  padding-left: 5px;
  padding-top: 10px;
  padding-bottom: 0px;
  min-width: 350px;
}
.v-col {
  padding: 0px;
}
</style>
